<template>
  <div class="themeColor fontColor" style="width: 100vw;height: 47px;line-height: 46px;background-color:#14212b">
    <div style="position: relative">
        <img src="../assets/logo.png"  style="width: 40px;position: absolute;top: 3px;left: 6px;cursor: pointer;">
      <span style="float: left;font-size: 22px;font-style:oblique;font-weight: bold;margin-left: 50px;" >贝壳王国票务综合系统</span>
      <span style="float: right;margin-right: 50px;">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link" style="color:#fff;cursor:pointer">欢迎您：{{realName}}
              <i class="el-icon-caret-bottom"></i>
              <img v-if="this.CommonUtil.getUserInfo().sex == 1" class="head" style="border-radius:50%;" src="../assets/man.png" />
              <img v-if="this.CommonUtil.getUserInfo().sex != 1" class="head" style="border-radius:50%;" src="../assets/woman.png" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="clearfix" command="reset">修改密码</el-dropdown-item>
              <el-dropdown-item class="clearfix" command="changeData">修改个人信息</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        <span class="head" style="cursor:pointer" @click="logout">退出</span>
      </span>
    </div>


    <el-dialog title="修改我的密码" :close-on-press-escape="false"	 :show-close="!hintVisible" :visible.sync="resetShow" width="30%" @close="clearReset" :close-on-click-modal="false" :fullscreen="false">
      <el-form label-position="right" :inline="true" :rules="resetRule" label-width="80px" :model="resetForm" ref="resetForm">
        <el-form-item label="原密码" prop="oldPass">
          <el-input type="password" v-model="resetForm.oldPass" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPass">
          <el-input type="password" v-model="resetForm.newPass" />
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="resetForm.checkPass" />
        </el-form-item>
        <!--<el-form-item >-->
          <!--<span class="bs">初次登陆请修改密码</span>-->
        <!--</el-form-item>-->
        <el-row style="margin-top:-15px" v-if="hintVisible">
          <el-col :span="20"><span style="color: red">初次登录请修改密码</span></el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetShow = false"  v-if="!hintVisible">取 消</el-button>
        <el-button type="primary" @click="resetPassword">修 改</el-button>
      </span>
    </el-dialog>


    <!-- 修改个人信息 -->
    <el-dialog :title="dialogTitle" :visible.sync="addVisible" :fullscreen="false" @close="closeUD" width="1000px" :close-on-click-modal="false">
      <changeUD :examUser="userD" @finish="finish" @close="closeUD"></changeUD>
    </el-dialog>
  </div>
</template>

<script>
import changeUD from '@/components/user/changeUD'

export default {
  components: {
    changeUD,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
        if (!reg.test(value)) {
          callback(new Error('密码长度要大于等于6位，由数字和字母组成'))
        }else{
          if (this.resetForm.checkPass !== '') {
            this.$refs.resetForm.validateField('checkPass');
          }
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      }else if (value !== this.resetForm.newPass) {
        callback(new Error('两次输入密码不一致!'));
      }  else {
        callback();
      }
    };
    return {
      dialogTitle: '修改个人信息',
      addVisible: false,
      hintVisible:false,
      userD: {
        username: '',
        realname: '',
        sex: '',
        mobile: '',
        tel: '',
        email: '',
        id: ''
      },
      headUrl: '#21d1a8',
      resetShow: false,
      username: '未登录',
      realName: '未登录',
      resetForm: {
        oldPass: '',
        newPass: '',
        checkPass: ''
      },
      resetRule: {
        newPass: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        },{
          validator: validatePass,
          trigger: 'blur'
        }],
        checkPass: [{
          required: true,
          message: '请重新输入新密码',
          trigger: 'blur'
        },{
          validator: validatePass2,
          trigger: 'blur'
        }],
        oldPass: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }],
      },
    };
  },
  mounted: function() {
    this.realName = this.CommonUtil.getUserInfo().realName;
    // var a = this.CommonUtil.getUserInfo();
    // if (a.initPassword == 1){
    //   this.resetShow =true;
    //   this.hintVisible = true;
    // }else if(a.mobile == '0'){
    //   this.changeData()
    // }
  },
  methods: {
    //未操作，直接关闭信息维护窗口后触发事件。
    closeUD(){
      //关闭弹出框，并清除用户信息。
      this.addVisible = false;
      this.userD = {
        username: '',
        realname: '',
        sex: '',
        mobile: '',
        tel: '',
        email: '',
        id: ''
      }
    },
    //操作后关闭信息维护窗口触发。【即数据修改后的变动】
    finish(value){
      this.addVisible = false;
      this.userD = {
        username: '',
        realname: '',
        sex: '',
        mobile: '',
        tel: '',
        email: '',
        id: ''
      }

      //更新缓存
      var user = this.CommonUtil.getUserInfo();
      this.realName = value.realname;
      window.localStorage.setItem(
        this.GLOBAL.USER_INFO,
        JSON.stringify(user)
      );
    },

    clearReset(){
      this.resetShow = false;
      this.$refs['resetForm'].resetFields();
    },
    handleCommand(command){
      if(command == 'reset'){
        this.resetShow = true;
      } else if(command == 'changeData'){
        this.changeData();
      }
    },
    changeData(){
      // this.addVisible = true;
      this.$axios.get('/user/searchUser?id=' + this.CommonUtil.getUserInfo().userId).then(res => {
        let o = res.data;
        this.userD.username = o.username;
        this.userD.realname = o.realname;
        this.userD.sex = o.sex;
        if(o.mobile == null || o.mobile == 0 || o.mobile == '') {
          this.userD.mobile = '';
        }else {
          this.userD.mobile = o.mobile;
        }
        this.userD.tel = o.tel;
        this.userD.email = o.email;
        this.userD.id = o.id;
        this.addVisible = true;
      });
    },
    resetPassword() {
      this.$refs["resetForm"].validate(valid => {
        if (valid) {
          this.$axios.post("/user/reset", this.resetForm).then(response => {
            if (response.code == "0000") {
              this.$alert("密码修改成功，请重新登录", "", {
                confirmButtonText: "确定",
                callback: action => {
                  this.$axios.get("/user/logout").then(() => {
                    window.localStorage.removeItem(this.GLOBAL.USER_TOKEN);
                    window.localStorage.removeItem(this.GLOBAL.USER_INFO);
                    window.localStorage.removeItem(this.GLOBAL.USER_MENU);
                    window.localStorage.removeItem(this.GLOBAL.USER_AUTH);
                    window.localStorage.removeItem(this.GLOBAL.SYS_CODE);
                    this.$router.push("/login");
                  });
                }
              });
            } else {
              this.$message({
                message: response.message,
                type: "error"
              });
            }
          });
        }
      });
    },
    logout() {
      this.$confirm("是否退出当前用户?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios.get("/user/logout").then(() => {
          window.localStorage.removeItem(this.GLOBAL.USER_TOKEN);
          window.localStorage.removeItem(this.GLOBAL.USER_INFO);
          window.localStorage.removeItem(this.GLOBAL.USER_MENU);
          window.localStorage.removeItem(this.GLOBAL.USER_AUTH);
          window.localStorage.removeItem(this.GLOBAL.SYS_CODE);
          this.$router.push("/login");
        });
      });
    },
    headClick() {
      $("#headMenu").toggle(200);
    }
  }
};

</script>

<style scoped>
.head {
  width: 40px;
  height: 40px;
  vertical-align: middle;
  font-size: 18px;
  cursor: pointer;
}

p {
  padding: 10px 0px;
}

p:hover {
  cursor: pointer;
  background-color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue